export default function auth({
    next,
    router
}) {
    if (localStorage.getItem('id')) return router.push({
        name: 'home'
    });

    return next();
}